const postingDatePolicy = {
  PostingDatePolicy: "Política de Fecha de Contabilización",
  posting_date_policy: "Política de Fecha de Contabilización",
  posting_date_policies: "Políticas de Fecha de Contabilización",
  add_posting_date_policy: "Agregar Política de Fecha de Contabilización",
  edit_posting_date_policy: "Editar Política de Fecha de Contabilización",
  name: "Nombre",
  cut_off_day: "Día de Corte",
  status: "Estado",
  actions: "Acciones",
  active: "Activa",
  inactive: "Inactiva",
  activate: "Activar",
  edit: "Editar",
  delete: "Eliminar",
  cancel: "Cancelar",
  add: "Agregar",
  update: "Actualizar",
  something_went_wrong: "Algo salió mal",
  no_posting_date_policies_found:
    "No se encontraron políticas de fecha de contabilización",
  posting_date_policy_rules_column: "Reglas de Fecha de Contabilización",
  posting_date_policy_same_month_before_rule:
    "Revisado en el Mismo Mes (En/Antes del Día de Corte)",
  posting_date_policy_same_month_after_rule:
    "Revisado en el Mismo Mes (Después del Día de Corte)",
  posting_date_policy_early_rule:
    "Revisado el Mes Anterior (En/Antes del Día de Corte)",
  posting_date_policy_late_rule:
    "Revisado el Mes Anterior (Después del Día de Corte)",
  posting_date_policy_same_month_before_label: "Mismo mes, en/antes de {{day}}",
  posting_date_policy_same_month_after_label: "Mismo mes, después de {{day}}",
  posting_date_policy_prior_month_on_before_label:
    "Mes anterior, en/antes de {{day}}",
  posting_date_policy_prior_month_after_label:
    "Mes anterior, después de {{day}}",
  posting_date_policy_name_hint:
    "Asigne un nombre claro a esta política y defina el día de corte.",
  posting_date_policy_cutoff_day_hint:
    "Define el límite para las facturas (1–31).",
  posting_date_policy_same_month_section_title: "Reglas del mismo mes",
  posting_date_policy_same_month_section_subtitle:
    "Se aplica cuando la factura pertenece al mismo mes que la revisión, según el día de corte definido arriba.",
  posting_date_policy_prior_month_section_title: "Reglas del mes anterior",
  posting_date_policy_prior_month_section_subtitle:
    "Se aplica cuando la factura pertenece a un mes anterior al mes de revisión, según el día de corte definido arriba.",
  posting_date_type_review_date: "Fecha de Revisión / Integración",
  posting_date_type_invoice_date: "Fecha de Factura",
  posting_date_type_last_day_of_invoice_month:
    "Último Día del Mes de la Factura",
  posting_date_type_first_day_of_review_month: "Primer Día del Mes de Revisión",
  posting_date_type_last_day_of_review_month:
    "Último día del mes anterior (a partir de la fecha de revisión)",
  posting_date_type_day_after_cuttoff_review_month:
    "Día siguiente a la fecha límite (mes de revisión)",
  posting_date_type_first_day_of_previous_review_month:
    "Primer Día del Mes Anterior (a partir de la Fecha de Revisión)",
  posting_date_policy_name_required: "El nombre es obligatorio",
  posting_date_policy_cutoff_days_required: "El día de corte es obligatorio",
  posting_date_policy_cutoff_days_range:
    "El día de corte debe estar entre 1 y 31",
  posting_date_policy_rule_required: "Esta regla es obligatoria",
  posting_date_policy_created_successfully:
    "Política de fecha de contabilización creada correctamente",
  posting_date_policy_updated_successfully:
    "Política de fecha de contabilización actualizada correctamente",
  posting_date_policy_deleted_successfully:
    "Política de fecha de contabilización eliminada correctamente",
  posting_date_policy_activated_successfully:
    "Política de fecha de contabilización activada correctamente",
  cannot_delete_active_posting_date_policy:
    "La política de fecha de contabilización activa no se puede eliminar, desactívela para eliminarla",
  posting_date_policy_deactivated_successfully:
    "Política de fecha de contabilización desactivada correctamente",
  delete_posting_date_policy_title:
    "Eliminar Política de Fecha de Contabilización",
  delete_posting_date_policy_description:
    "¿Está seguro de que desea eliminar esta política de fecha de contabilización?",
};

export default postingDatePolicy;
